<template>
  <detailTemplate :classCustom="'detail-docs extend-detail'">
    <template #content>
      <div class="back-icon border-radius__50 clickable flex-row flex__center" @click="backListPage()">
        <i class="el-icon-back font-size__large"></i>
      </div>

      <!--content-->
      <VuePerfectScrollbar class="scroll-area">
        <div class="body">
          <div class="font-size__large font-weight__bold margin-bottom-10" style="color: #007aff">
            NHẬN VĂN BẢN TRẢ RA
          </div>

          <!--THÔNG TIN YÊU CẦU & THÔNG TIN PHÒNG HỌP-->
          <div class="form-info padding-right-10 padding-bottom-10">
            <el-form inline-message>
              <div class="group__info margin-top-10 padding-bottom-10">
                <div class="content">
                  <div class="form-input">
                    <div class="title font-size__medium font-weight__bold margin-bottom-10 margin-top-10">THÔNG TIN VĂN
                      BẢN
                    </div>
                    <!--tieu de-->
                    <el-form-item class="custom-label__input width25">
                      <span class="label-input">Số văn bản:</span>
                      <el-input type="text" class="input-border__bottom input-border__radius__0 input-font__bold"
                                @blur="hcCaseDoc.docNum = hcCaseDoc.docNum.trim()"
                                size="mini" :readonly="true"
                                clearable maxlength="255" ref="title"
                                v-model="hcCaseDoc.docNum"
                      />
                    </el-form-item>

                    <el-form-item class="custom-label__input width25">
                      <span class="label-input">Số ký hiệu văn bản:</span>
                      <el-input type="text" class="input-border__bottom input-border__radius__0 input-font__bold"
                                @blur="hcCaseDoc.docSign = hcCaseDoc.docSign.trim()"
                                size="mini" :readonly="true"
                                clearable maxlength="255" ref="title"
                                v-model="hcCaseDoc.docSign"
                      />
                    </el-form-item>

                    <el-form-item class="custom-label__input width25">
                      <span class="label-input">Đơn vị ban hành:</span>
                      <el-input type="text" class="input-border__bottom input-border__radius__0 input-font__bold"
                                size="mini" :readonly="true"
                                clearable maxlength="255" ref="title"
                                v-model="hcCaseDoc.requestDeptName"
                      />
                    </el-form-item>

                    <el-form-item class="custom-label__input width25">
                      <span class="label-input">Ngày văn bản:</span>
                      <VueCtkDateTimePicker
                        color="#2d3e4f"
                        button-color="#2d3e4f"
                        :no-label="true"
                        label
                        disabled
                        :no-header="true"
                        v-model="hcCaseDoc.docDateFormatted"
                        class="picker-no_boder"
                        format="x"
                        output-format="x"
                        formatted="L"
                        :only-date="true"
                      />
                    </el-form-item>

                    <div class="title font-size__medium font-weight__bold margin-bottom-10 margin-top-10">THÔNG TIN
                      CHUYỂN VĂN BẢN
                    </div>

                    <el-table
                      :data="hcCaseDocOrgs"
                      style="width: 100%">
                      <el-table-column
                        label="LÃNH ĐẠO">
                        <template slot-scope="scope">
                          <div>
                            {{approverName(scope.row.approverId)}}
                          </div>
                        </template>
                      </el-table-column>

                      <el-table-column
                        label="ĐƠN VỊ NHẬN VĂN BẢN">
                        <template slot-scope="scope">
                          <div>
                            {{deptName(scope.row.returnDeptId)}}
                          </div>
                        </template>
                      </el-table-column>

                      <el-table-column
                        label="NỘI DUNG CHỈ ĐẠO">
                        <template slot-scope="scope">
                          <div>{{scope.row.directionContent}}</div>
                        </template>
                      </el-table-column>

                      <el-table-column
                        label="DEADLINE">
                        <template slot-scope="scope">
                          <div>
                            {{deadline(scope.row.deadline)}}
                          </div>
                        </template>
                      </el-table-column>

                      <el-table-column
                        fixed="right"
                        label="BÁO CÁO">
                        <template slot-scope="scope">
                          <el-checkbox :disabled="true" v-model="scope.row.isNeedReportBoolean"></el-checkbox>
                        </template>
                      </el-table-column>

                      <el-table-column
                        fixed="right"
                        label="THAO TÁC">
                        <template slot-scope="scope">
                          <el-button class="addDocs color__blue btn-none__border" size="mini"
                                     v-if="scope.row.isNeedReportBoolean && scope.row.orgStatus == 0"
                                     @click="handleReceive(scope.$index, scope.row)">
                            <i class="fas fa-arrow-circle-right font-size__small"></i>&nbsp;Nhận văn bản
                          </el-button>
                          <div v-if="scope.row.isNeedReportBoolean && scope.row.orgStatus == 1">Đã nhận</div>
                        </template>
                      </el-table-column>
                    </el-table>

                  </div>
                </div>
              </div>
            </el-form>
          </div>
        </div>
      </VuePerfectScrollbar>
      <!--footer-->
      <div class="footer">
        <div class="flex-row flex__between">
          <div class="flex-row flex__left form-button__action">

          </div>
        </div>
      </div>
    </template>
  </detailTemplate>
</template>

<script type="text/javascript">
    import VuePerfectScrollbar from "vue-perfect-scrollbar";
    import handleRequestErrorMixin from "../../handleRequestErrorMixin";
    import hanhchinhService from "../../../services/hanhchinhService";
    import {EventBus} from "../../../event-bus.js";
    import moment from "moment";
    import constants from "../../../constants";
    import h from "../../../services/h";

    export default {
        name: "luongVb_DetailReceive",
        mixins: [handleRequestErrorMixin],
        data() {
            return {
                leaders: [],
                listDept: [],
                hcCaseDoc: {},
                hcCaseDocOrgs: [],
                hcCaseDocTransferApprovers: [],
                hcCaseDocApprovers: []
            }
        },

        components: {
            VuePerfectScrollbar,
            detailTemplate: () => import("../../common/detail.vue"),
            Multiselect: () => import("vue-multiselect"),
            VueCtkDateTimePicker: () => import ("vue-ctk-date-time-picker")
        },

        created() {
            this.getData();
            this.getListLd();
            this.getListDept();
        },

        computed: {
            caseMasterId() {
                return this.$route.params.id;
            },

            currentDeptId() {
                let userDeptRole = h.find(
                    this.$store.state.userDeptRoles,
                    userDeptRole => userDeptRole.id === this.$store.getters.userDeptRoleId
                );
                return userDeptRole.deptId;
            },

            parentDeptId() {
                let userDeptRole = h.find(
                    this.$store.state.userDeptRoles,
                    userDeptRole => userDeptRole.id === this.$store.getters.userDeptRoleId
                );
                return userDeptRole.parentDeptId;
            }
        },

        methods: {
            backListPage() {
                this.$router.push({
                    name: "vbLuongVanBan",
                    query: this.$route.query,
                    params: this.$route.params
                });
            },

            getData() {
                hanhchinhService.getDetailReturn(this.caseMasterId).then(res => {
                    this.hcCaseDoc = {
                        caseMasterId: res.data.hcCaseDoc.caseMasterId,
                        docSign: res.data.hcCaseDoc.docSign,
                        docNum: res.data.hcCaseDoc.docNum,
                        docDateFormatted: res.data.hcCaseDoc.docDate !== null ? moment(res.data.hcCaseDoc.docDate).format("x") : null,
                        requestDeptName: res.data.hcCaseDoc.requestDeptName
                    };

                    this.hcCaseDocOrgs = [];
                    for (let i = 0; i < res.data.hcCaseDocOrgs.length; i++) {
                        let hcCaseDocOrg = res.data.hcCaseDocOrgs[i];

                        if (hcCaseDocOrg.returnDeptId == this.currentDeptId) {
                            this.hcCaseDocOrgs.push({
                                id: hcCaseDocOrg.id,
                                deadline: hcCaseDocOrg.deadline,
                                isNeedReportBoolean: hcCaseDocOrg.isNeedReport == 1,
                                approverId: hcCaseDocOrg.approverId,
                                approverFullname: hcCaseDocOrg.approverFullname,
                                returnDeptName: hcCaseDocOrg.returnDeptName,
                                returnDeptId: hcCaseDocOrg.returnDeptId,
                                directionContent: hcCaseDocOrg.directionContent,
                                orgStatus: hcCaseDocOrg.orgStatus
                            });
                        }
                    }

                    this.hcCaseDocApprovers = [];
                    for (let i = 0; i < res.data.hcCaseDocApprovers.length; i++) {
                        this.hcCaseDocApprovers.push({
                            approverFullname: res.data.hcCaseDocApprovers[i].approverFullname,
                            approverId: res.data.hcCaseDocApprovers[i].approverId,
                        });
                    }

                });
            },

            deptName(deptId) {
                for (let i=0; i<this.listDept.length; i++) {
                    if (deptId == this.listDept[i].id) {
                        return this.listDept[i].name;
                    }
                }
                return "N/A";
            },

            approverName(approverId) {
                for (let i=0; i<this.hcCaseDocApprovers.length; i++) {
                    if (approverId == this.hcCaseDocApprovers[i].approverId) {
                        return this.hcCaseDocApprovers[i].approverFullname;
                    }
                }
                return "N/A";
            },

            deadline(timestamp) {
                return moment(timestamp).format("DD/MM/YYYY");
            },

            getListLd() {
                this.leaders = [];
                hanhchinhService.getListLD(this.$store.getters.globalRoles).then(res1 => {
                    res1.data.listLd.forEach(item => {
                        this.leaders.push(item);
                    });
                    hanhchinhService.getListLD(constants.HDTV_DEPT_CODE).then(res2 => {
                        res2.data.listLd.forEach(item => {
                            this.leaders.push(item);
                        });
                    });
                });
            },

            getListDept() {
                hanhchinhService.getDept(this.parentDeptId).then(res => {
                    res.data.departments.forEach(dept => {
                        this.listDept.push({
                            id: dept.id,
                            name: dept.deptName
                        });
                    });
                });
            },

            handleReceive(index, row) {
                let form = {
                    hcCaseDocOrgId: row.id
                };

                hanhchinhService.donViNhanVanBan(form).then(respone => {
                    this.notifySuccess("Nhận văn bản thành công");
                    this.getData();
                    EventBus.$emit("reloadPage", {});
                });
            },

            notifyError(msg) {
                this.notify('Lỗi', msg, 'error', 2000);
            },
            notifySuccess(msg) {
                this.notify('Thông báo', msg, 'success', 2000);
            },
        }
    };
</script>

<style scoped>
  .icon_action {
    font-size: 15px;
    padding: 10px;
  }

  .icon_action:hover {
    background: white;
    box-shadow: 0 8px 15px rgba(39, 124, 190, 0.25);
  }

  .createNew {
    background-color: var(--color-green);
    padding: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/adminstration/luongvanban/luongVb_DetailReceive.vue